(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/helpers/shared-helpers.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/helpers/shared-helpers.js');
'use strict';

var _svs;
const logger = svs.accountservicesReact.deposit.depositShared.logger;
const jupiter = svs.core.jupiter;
const _svs$accountservicesR = svs.accountservicesReact.deposit.tracking.sharedTracking,
  trackSuccess = _svs$accountservicesR.trackSuccess,
  trackFailure = _svs$accountservicesR.trackFailure;
const amountLimits = svs.accountservicesReact.deposit.constants.amountLimits;
const KYC_ERROR = 100020;

const getErrorCode = error => {
  var _error$responseJSON;
  const errorCode = error.code || error.errorCode || (error === null || error === void 0 || (_error$responseJSON = error.responseJSON) === null || _error$responseJSON === void 0 || (_error$responseJSON = _error$responseJSON.error) === null || _error$responseJSON === void 0 ? void 0 : _error$responseJSON.code) || 1;
  const errorCodeInt = typeof errorCode === 'string' ? parseInt(errorCode.replace(/ /g, ''), 10) : parseInt(errorCode, 10);
  return isNaN(errorCodeInt) ? 1 : errorCodeInt;
};

const swedbankpayErrorTranslate = errorCode => {
  switch (errorCode) {
    case 2:
      return 1;
    case 3:
      return 1131;
    case 4:
      return 1033;
    case 6:
      return 100031;
    case 7:
      return 100033;
    case 8:
      return 100034;
    case 9:
      return 100035;
    case 10:
      return 100037;
    case 1:
    case 5:
    default:
      return errorCode;
  }
};

const getAccountBalanceAsync = () => new Promise(resolve => {
  svs.components.account_balance.get(true, balance => {
    resolve(balance);
  });
});

const updateBalanceAsync = async accountBalance => {
  if (!accountBalance) {
    return await getAccountBalanceAsync();
  }
  svs.components.account_balance.set(accountBalance);
  return accountBalance;
};

const setLastDepositMethodAsync = async paymentMethod => {
  svs.components.Storage.browser.set('lastPaymentMethod', 'transactions', paymentMethod, svs.components.Storage.constants.EXPIRES_1YEAR, error => {
    if (error) {
      logger.info('Failed to set lastPaymentMethod to local storage.', jupiter.parseErrorResponse(error));
    } else {
      logger.debug('Success setting lastPaymentMethod to local storage.');
    }
  });
};
const handleError = (err, paymentMethod, transactionData, maxLimitLeft) => {
  const showDepositError = svs.accountservicesReact.deposit.dialogs.sharedDialogs.showDepositError;
  const errorCode = getErrorCode(err);
  trackFailure(paymentMethod, errorCode);
  switch (errorCode) {
    case KYC_ERROR:
      svs.core.module.load('/cl/components/kyc-messages', null, () => {
        svs.components.kyc_messages.showKYCMessage();
      });
      break;
    case 100037:
    case 10:
      location.reload();
      return;
    case 11:
      showDepositError({
        code: 50105
      }, transactionData, maxLimitLeft); 
      break;
    case 12:
      showDepositError({
        code: 50107
      }, transactionData, maxLimitLeft);
      break;
    default:
      showDepositError(err, transactionData, maxLimitLeft);
      break;
  }
};
const successCleanup = async successEventData => {
  await trackSuccess(successEventData === null || successEventData === void 0 ? void 0 : successEventData.paymentType, successEventData === null || successEventData === void 0 ? void 0 : successEventData.amount);
  const accountBalance = await updateBalanceAsync(successEventData.accountBalance);
  return accountBalance;
};
const hasInstantPayAmount = instantPay => {
  const instantPayAmountNumeric = isNaN(Number(instantPay === null || instantPay === void 0 ? void 0 : instantPay.amount)) ? 0 : Number(instantPay === null || instantPay === void 0 ? void 0 : instantPay.amount);
  const isNotAutoPay = (instantPay === null || instantPay === void 0 ? void 0 : instantPay.isPay) !== undefined && (instantPay === null || instantPay === void 0 ? void 0 : instantPay.isPay) === false;
  return isNotAutoPay && instantPayAmountNumeric >= amountLimits.MIN && instantPayAmountNumeric <= amountLimits.MAX;
};

const onboardingData = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservicesReact) === null || _svs === void 0 || (_svs = _svs.deposit) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.extraDataOnboarding) || {};

const getOnboardingProductInfo = extraData => {
  var _extraData$product;
  const capitalizeString = svs.utils.format.capitalize;

  const productInfo = {
    productInfo: extraData !== null && extraData !== void 0 && extraData.product ? capitalizeString(extraData === null || extraData === void 0 ? void 0 : extraData.product, true) : '',
    productAmountInfo: extraData !== null && extraData !== void 0 && extraData.amount ? "".concat(extraData === null || extraData === void 0 ? void 0 : extraData.amount, " kr") : ''
  };

  if ((extraData === null || extraData === void 0 || (_extraData$product = extraData.product) === null || _extraData$product === void 0 ? void 0 : _extraData$product.toLowerCase()) === 'kenoxpress') {
    productInfo.productInfo = 'Ditt KenoXpress-spel';
  }
  return productInfo;
};

const removeUrlAfterPayServerAsync = () => new Promise(resolve => {
  svs.core.userSession.remove('urlafterpayserver', () => {
    resolve();
  });
});

const navigateOnPayTrue = returnUrl => {
  var _returnUrl;
  if (!returnUrl || ((_returnUrl = returnUrl) === null || _returnUrl === void 0 ? void 0 : _returnUrl.length) === 0) {
    return;
  }
  let hash = '';
  if (returnUrl.includes('#')) {
    hash = "#".concat(returnUrl.split('#')[1]);
    returnUrl = returnUrl.split('#')[0];
  }
  if (returnUrl.includes('pay=true') || returnUrl.includes(svs.core.urlMapping.get('fractiongamesHome')) || returnUrl.includes(svs.core.urlMapping.get('playTogetherHome'))) {
    let extraParam = '';
    if (!returnUrl.includes('afterpay')) {
      extraParam = "".concat(returnUrl.includes('?') ? '&' : '?', "afterpay").concat(hash);
    }
    svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl + extraParam));
    return true;
  }
};
svs.accountservicesReact.deposit.helpers.sharedHelpers = {
  swedbankpayErrorTranslate,
  getErrorCode,
  getOnboardingProductInfo,
  onboardingData,
  updateBalanceAsync,
  setLastDepositMethodAsync,
  successCleanup,
  handleError,
  hasInstantPayAmount,
  removeUrlAfterPayServerAsync,
  navigateOnPayTrue
};

 })(window);